import React, { useState, useEffect } from 'react';
import { PWAInstall } from '../utils/pwaUtils';
import './PWAInstallBanner.css';

/**
 * PWA Install Banner Component
 * Prompts mobile/tablet users to install the app
 */
function PWAInstallBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    // Check if already installed
    const isInstalled = window.matchMedia('(display-mode: standalone)').matches ||
                       window.navigator.standalone === true;
    
    setIsPWA(isInstalled);

    if (!isInstalled) {
      // Check if user dismissed banner before
      const dismissed = localStorage.getItem('pwa-banner-dismissed');
      const dismissedDate = dismissed ? new Date(dismissed) : null;
      const now = new Date();
      
      // Show banner if not dismissed or if 7 days have passed
      if (!dismissed || (now - dismissedDate) > 7 * 24 * 60 * 60 * 1000) {
        // Wait for install prompt
        PWAInstall.init(() => {
          setShowBanner(true);
        });
      }
    }
  }, []);

  const handleInstall = async () => {
    const accepted = await PWAInstall.promptInstall();
    
    if (accepted) {
      setShowBanner(false);
      localStorage.removeItem('pwa-banner-dismissed');
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-banner-dismissed', new Date().toISOString());
  };

  // Don't show if already PWA or banner dismissed
  if (isPWA || !showBanner) {
    return null;
  }

  return (
    <div className="pwa-install-banner">
      <div className="pwa-banner-content">
        <div className="pwa-banner-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="4" fill="#06b6d4"/>
            <path d="M8 12l3 3 5-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <div className="pwa-banner-text">
          <h3 className="pwa-banner-title">Instale o QRCodeXpress</h3>
          <p className="pwa-banner-description">
            Acesso rápido, funciona offline e ocupa pouco espaço
          </p>
        </div>
      </div>

      <div className="pwa-banner-actions">
        <button 
          className="pwa-banner-btn pwa-banner-dismiss" 
          onClick={handleDismiss}
          aria-label="Dispensar"
        >
          Agora não
        </button>
        <button 
          className="pwa-banner-btn pwa-banner-install" 
          onClick={handleInstall}
          aria-label="Instalar aplicativo"
        >
          Instalar
        </button>
      </div>

      <button 
        className="pwa-banner-close" 
        onClick={handleDismiss}
        aria-label="Fechar"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M6 6l12 12M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      </button>
    </div>
  );
}

export default PWAInstallBanner;
